import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '../../static/icons/scroll_arrow_white_right.svg'


const _hoisted_1 = { class: "main-links" }

import { ref } from 'vue';
import useStoryblokLink from '@/composables/useStoryblokLink';
import useContext from '@/composables/useContext';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLinks',
  props: {
  links: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { texts } = useContext();
const { toUrl } = useStoryblokLink();



const isOpen = ref(false);

function toggle() {
  isOpen.value = !isOpen.value;
}


return (_ctx: any,_cache: any) => {
  const _component_rich_text = _resolveComponent("rich-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", {
      class: "main-links__title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle()))
    }, [
      _createTextVNode(_toDisplayString(_unref(texts)('footer__support')) + " ", 1),
      _createElementVNode("img", {
        class: _normalizeClass(["main-links__title-arrow", {'main-links__title-arrow--open': isOpen.value}]),
        src: _imports_0
      }, null, 2)
    ]),
    _createElementVNode("ul", {
      class: _normalizeClass(["main-links__list", {'main-links__list--closed': !isOpen.value}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.links, (link) => {
        return (_openBlock(), _createElementBlock("li", {
          key: link._uid,
          class: "main-links__item"
        }, [
          _createVNode(_component_router_link, {
            to: _unref(toUrl)(link.link) || '#'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_rich_text, {
                value: link.label
              }, null, 8, ["value"])
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ], 2)
  ]))
}
}

})